import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { WithIntlProps, WrappedComponentProps } from 'react-intl';
import type { ViewChangesDialogPropsType } from './types.ts';

export const ViewChangesDialogLoader: LoadableType<
	WithIntlProps<ViewChangesDialogPropsType & WrappedComponentProps & DialogsContainerProps>
> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewChangesDialog" */ './ViewChangesDialog.tsx'))
			.ViewChangesDialog,
});
